import React, { useContext } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import {
  HrFlexContainer,
  HrFontBold,
  HrPrimary,
  HrSecondary,
  HrTransition,
  HrWhite,
  HrTransitionDuration,
  HrTransitionTimingCunction,
  HrFont
} from '@components/styles/hr-styles';
import { useNavigate, useLocation } from 'react-router-dom';
import useStore from '../store/useStore';
import { DisplaySettingsContext } from '../store/display-settings';

const TabItem = styled.div`
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: ${(props) => props.color || HrSecondary};
  cursor: pointer;
  font-family:${HrFont}
  transition: font-weight ${HrTransitionDuration} ${HrTransitionTimingCunction};

  &.active {
    color: ${HrPrimary};
    font-weight: ${HrFontBold};
    /* min-width: 100px; */
    padding: 0 8px;
  }

  & p{
    margin: 0;
    margin-bottom: -16px;
  }

  & div {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 0px;
    transition: ${HrTransition};
    transition-property: height;
    background-color: ${HrPrimary};
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
  }

  & div.active {
    height: 6px;
  }

  & .hide-desktop{
    display: none;
  }

  @media (max-width: 768px) {
    & .hide-mobile{
    display: none;
  }
    & .hide-desktop{
    display: block;
    border: 1px solid ${HrPrimary};
    border-radius: 50px;
    padding: 4px 10px;
    color: ${HrPrimary};

    &.active{
      background: ${HrPrimary};
      color: ${HrWhite};
    }
  }
  }
`;

export const Tabs = observer(({ maxWidth, arrRequeriment, hasQuestions, hasAttachedFiles = false }) => {
  const { currentStep } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [t] = useTranslation();
  const setNewCurrentStep = (newStep) => {
    navigate({
      pathname: location.pathname,
      replace: true,

      search: location.search,
      state: { currentStep: newStep },
      hash: `step${newStep}`
    });
  };

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer justifyContent='center'>
      <HrFlexContainer justifyContent='space-evenly' maxWidth={maxWidth} margin='0px 10px'>
        <TabItem color={darkMode ? '#9A9A9A' : ''} className={currentStep <= 3 ? 'active' : ''} onClick={() => setNewCurrentStep(1)}>
          <p style={{fontSize: `${16 + fontSizeSetting}px`}} className='hide-mobile'>{t('postulant.tabs.one')}</p>
          <p className={`${currentStep === 1 ? 'active' : ''} hide-desktop`}>1</p>
          <div className={currentStep === 1 ? 'active' : ''} />
        </TabItem>
        <TabItem color={darkMode ? '#9A9A9A' : ''} className={currentStep <= 3 && currentStep >= 2 ? 'active' : ''} onClick={() => setNewCurrentStep(2)}>
          <p style={{fontSize: `${16 + fontSizeSetting}px`}}  className='hide-mobile'>{t('postulant.tabs.two')}</p>
          <p className={`${currentStep === 2 ? 'active' : ''} hide-desktop`}>2</p>
          <div className={currentStep === 2 ? 'active' : ''} />
        </TabItem>
        {(arrRequeriment || hasQuestions || hasAttachedFiles) && (
          <TabItem color={darkMode ? '#9A9A9A' : ''} className={currentStep === 3 ? 'active' : ''} onClick={() => setNewCurrentStep(3)}>
            <p style={{fontSize: `${16 + fontSizeSetting}px`}} className='hide-mobile'>{t('postulant.tabs.three')}</p>
            <p className={`${currentStep === 3 ? 'active' : ''} hide-desktop`}>3</p>
            <div className={currentStep === 3 ? 'active' : ''} />
          </TabItem>
        )}
      </HrFlexContainer>
    </HrFlexContainer>
  );
});
